export default __webpack_public_path__ + "static/media/orage.8fd0c957.ogg";